<template>
  <div class="leading-relaxed space-y-10">
    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        1. Принятие условий
      </h2>
      <p>
        Заходя на MEDIUM.am или используя его, вы соглашаетесь соблюдать
        настоящие Условия использования. Если вы не согласны с этими условиями,
        пожалуйста, не используйте нашу платформу.
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">2. О сервисе</h2>
      <p>
        MEDIUM.am — это общественная платформа, созданная для объединения
        художников и любителей искусства. Мы предоставляем инструменты для
        создания профилей, поиска и сетевого взаимодействия.
      </p>
      <p class="mt-2">
        <strong>Роль посредника:</strong> MEDIUM.am выступает исключительно как
        связующее звено. Мы не участвуем и не являемся стороной каких-либо
        соглашений, продаж или сделок между пользователями.
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        3. Учетные записи пользователей и безопасность
      </h2>
      <p>
        Для использования определенных функций вы должны зарегистрировать
        аккаунт через электронную почту или Google Sign-In. Вы несете
        ответственность за:
      </p>
      <ul class="list-disc list-inside mt-2 space-y-1 ml-4">
        <li>
          Предоставление точной и полной информации (имя, электронная почта и т.
          д.).
        </li>
        <li>Поддержание безопасности вашей учетной записи.</li>
        <li>Все действия, которые происходят под вашей учетной записью.</li>
      </ul>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        4. Платежи и сторонние сделки
      </h2>
      <p>
        MEDIUM.am не обрабатывает платежи на данный момент. Любые финансовые
        операции, комиссии или покупки произведений искусства происходят строго
        между художником и любителем искусства через выбранные ими сторонние
        методы.
      </p>
      <p class="mt-2 font-medium text-red-600">
        Мы не несем ответственности за любые платежные споры, возвраты или
        неудачные доставки, возникшие в результате взаимодействия между
        пользователями на платформе.
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        5. Пользовательский контент и поведение
      </h2>
      <p>
        Пользователи несут единоличную ответственность за размещаемый ими
        контент (изображения, биографии, текст). MEDIUM.am — это пространство
        для человеческого творчества; следовательно:
      </p>
      <ul class="list-disc list-inside mt-2 space-y-1 ml-4 font-medium">
        <li class="text-red-600">
          Контент, созданный искусственным интеллектом (ИИ), строго запрещен.
        </li>
        <li>
          Контент должен быть напрямую связан с искусством и арт-сообществом.
        </li>
        <li>
          Контент не должен нарушать права интеллектуальной собственности.
        </li>
        <li>Запрещены незаконные, оскорбительные или вредоносные материалы.</li>
      </ul>
      <p class="mt-4 bg-gray-50 p-3 border-l-4 border-red-500 italic">
        <strong>Политика нулевой терпимости:</strong> Любые материалы, не
        связанные с искусством или созданные ИИ, будут обнаружены и безвозвратно
        удалены без предварительного уведомления.
      </p>
    </section>
    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        6. Импорт из Instagram
      </h2>
      <p>
        При использовании функции импорта из Instagram вы должны подключать
        аккаунт Instagram, которым владеете или которым имеете право управлять.
        Вы можете импортировать только тот контент, который имеете право
        использовать и публиковать.
      </p>
      <p class="mt-2">
        MEDIUM.am оставляет за собой право удалять импортированный контент,
        который, предположительно, был получен без разрешения или нарушает
        настоящие Условия использования.
      </p>
    </section>
    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        7. Ограничение ответственности
      </h2>
      <p>
        MEDIUM.am предоставляется на условиях «как есть» без каких-либо
        гарантий. Мы не несем ответственности за любые косвенные, случайные или
        последующие убытки, возникшие в результате использования вами платформы
        или вашего взаимодействия с другими пользователями.
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        8. Прекращение действия
      </h2>
      <p>
        Мы оставляем за собой право приостанавливать или удалять учетные записи,
        которые нарушают настоящие условия или ведут себя таким образом, который
        вредит сообществу.
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">8. Контакты</h2>
      <p>Вопросы об этих Условиях следует направлять по адресу:</p>
      <p class="text-primary font-bold mt-2">contact@medium.am</p>
    </section>

    <div class="text-center mt-10 text-sm italic">
      <p>
        Благодарим вас за то, что вы являетесь частью арт-сообщества MEDIUM.am.
      </p>
    </div>
  </div>
</template>
